<template>
  <!-- 转线索申请审批表单 -->
  <div class="transfer-clue">
    <!-- 申请信息提示区域 -->
    <div class="apply-banner">
      <div class="apply-row">
        <span class="apply-applicant">{{ currentClueInfo.createName }}申请</span>
        <span class="apply-type">{{ currentClueInfo.applyActionText }}</span>
      </div>
      <div class="apply-reason-row">
        <span class="reason-label">申请原因：</span>
        <span class="reason-value">{{ currentClueInfo.applyReason }}</span>
      </div>
    </div>
    <!-- 线索详情 -->
    <ClueDetail
      ref="clueDetailRef"
      :instanceId="currentClueInfo.doctorStageId || ''"
      :doctorId="currentClueInfo.doctorId || ''"
      :currentStepCode="currentClueInfo.currentStepCode"
    />
  </div>
</template>

<script>
export default {
  name: 'TransferClueApply',
  data() {
    return {
    }
  },
  props: {
    currentClueInfo: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    ClueDetail: () => import('./ClueDetail.vue')
  }
}
</script>

<style scoped lang="less">
.transfer-clue {
  height: 100%;
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 220px);
  overflow: auto;
}

// 申请信息提示区域
.apply-banner {
  flex-shrink: 0;
  background-color: #EBF6FF;
  border-radius: 4px;
  padding: 12px 16px;

  .apply-row {
    margin-bottom: 6px;

    &:last-child {
      margin-bottom: 0;
    }

    .apply-applicant {
      font-size: 14px;
      color: #1F2329;
      font-weight: 500;
    }

    .apply-type {
      font-size: 14px;
      color: #1890FF;
      font-weight: 500;
      margin-left: 6px;
    }
  }

  .apply-reason-row {
    font-size: 13px;
    line-height: 20px;

    .reason-label {
      color: #9AA0A8;
    }

    .reason-value {
      color: #1F2329;
    }
  }
}

// 让子组件 ClueDetail 占满剩余空间并支持内部滚动
/deep/ .clue-detail {
  flex: 1;
  max-height: none;
  overflow: hidden;
}
</style>